module.exports = __webpack_public_path__ + "static/media/iconTwo.53b6ce4f.svg";